import Approve from '../approveDia.vue';
// import { yyhtUrl } from "@/assets/js/commonData";
// import Api form "@/modules/projectA/api/enquiry/index"; 是from 不是 form
import Api from '@/modules/projectA/api/enquiry/index';
export default {
  components: {
    Approve
  },
  data() {
    return {
      ifSwitch: false,
      approvalList: [],
      activeApproval: {},
      approvalChain: {},
      authFlag: true,
      showAuditMask: false,
      noSwitch: false,
      auditId: '',
      approvalItem: {
        auditId: '',
        auditName: ''
      }
    };
  },
  created() {
    this.queryApprovalProcessSwitch();
  },
  methods: {
    //获取审批信息
    async getApprovalList() {
      let params = {
        auditType: 5
      };
      let res = await Api.approveList(params);
      if (res.code == 200) {
        this.approvalList = res.data;
        if (res.data.length == 1) {
          this.approvalItem = this.approvalList[0];
        }
      }
    },

    //配置审批流
    toSetApprove() {
      this.$router.push({ path: '/approveSetting' });
    },
    //选择审批流程
    choiceAudit() {
      this.showAuditMask = true;
    },
    //判断审批流的开关
    async queryApprovalProcessSwitch() {
      let res = await Api.queryOderConfig();
      if (res.code == 200) {
        if (res.data) {
          const { data } = res.data.find(item => item.dataType === 'orderAsk');
          this.ifSwitch = data === '41' ? true : false;
          if (this.ifSwitch) {
            this.getApprovalList();
          }
        } else {
          this.ifSwitch = false;
        }
      }
    },
    choosenApproval() {
      this.showAuditMask = false;
      this.activeApproval = this.approvalChain;
    },
    // 获取审批详情信息
    async getItemPid(val) {
      let res = await Api.approveDetail({ auditId: val });
      if (res.code == 200) {
        this.approvalItem = res.data || {};
      }
    },
    closeDialog() {
      this.showAuditMask = false;
    },
    getApprovalChain(val) {
      this.approvalItem = val;
      console.log(this.approvalItem, 'approvalItem');
    }
  }
};
